/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useTranslation } from 'react-i18next';

const TabsNavigation = ({ items, activeItem, onItemClick, className = '' }) => {
  const { t } = useTranslation();

  const onHandleItemClick = (item, e) => {
    e.preventDefault();
    onItemClick && onItemClick(item);
  };

  return (
    <div className={`border-bottom border-2 pb-md-7 d-flex d-md-block align-items-center ${className}`}>
      {items.map(item => {
        const isActive = item.state === activeItem;
        return (
          <a
            key={item.state}
            href='#'
            className={`pb-7 px-0 mb--2 mr-0 text-center text-md-left mr-md-15 col-6 col-md-none fw-500 ${
              isActive ? 'border-bottom border-3 border-primary rounded-1' : 'text-body'
            }`}
            onClick={onHandleItemClick.bind(null, item)}
          >
            {t(item.name)} {item.count ? `(${item.count})` : null}
          </a>
        );
      })}
    </div>
  );
};

export default TabsNavigation;
